import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  onsiteAdPreview: {
    width: '50%',
    margin: '20px auto'
  }
})

export default useStyles
